import Door from '@/services/api/door';

export default {
  state: {
    doors: {},
    door: {},
  },
  getters: {
    doors: state => state.doors,
  },
  mutations: {
    setDoors: (state, payload) => {
      state.doors = payload;
    },
    setDoor: (state, payload) => {
      state.door = payload;
    },
  },
  actions: {
    getDoors (state, id) {
      return new Promise((resolve, reject) => {
        Door.getDoors(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateDoor (state, data) {
      return new Promise((resolve, reject) => {
        Door.updateDoor(data)
          .then((data) => {
            state.commit('setDoor', data.data.data);
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getDoorsBarrier (state, id) {
      return new Promise((resolve, reject) => {
        Door.getDoorsBarrier(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    updateDoorBarrier (state, data) {
      return new Promise((resolve, reject) => {
        Door.updateDoorBarrier(data)
          .then((data) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    newDoorBarrier (state, params) {
      return new Promise((resolve, reject) => {
        Door.newDoorBarrier(params)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    removeDoorBarrier (state, { id, doornum }) {
      return new Promise((resolve, reject) => {
        Door.removeDoorBarrier(id, doornum)
          .then((response) => {
            resolve(response);
          })
          .catch(e => reject(e));
      });
    },
    editDoorOpenMod (state, { id, doorOpen, num }) {
      return new Promise((resolve, reject) => {
        Door.editDoorOpenMod(id, doorOpen, num)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
    getInfoDoorOpen (state, id) {
      return new Promise((resolve, reject) => {
        Door.getInfoDoorOpen(id)
          .then(({ data }) => {
            resolve(data);
          })
          .catch(e => reject(e));
      });
    },
  },
};
